import { CalculationFunctionValuesEnum } from '../../model';

export const fromCalculationFunctionValueToHumanReadable = (value: CalculationFunctionValuesEnum) => {
  const mapper = {
    [CalculationFunctionValuesEnum.CF0]: 'Разовое начисление бонусов при достижении уровня продаж',
    [CalculationFunctionValuesEnum.CF1]: 'План продаж по брендам',
    [CalculationFunctionValuesEnum.CF2]: 'План продаж по брендам, за выполнение плана начисляется бонус',
    [CalculationFunctionValuesEnum.CF3]: 'Приветственный бонус, участнику будет начислен бонус',
    [CalculationFunctionValuesEnum.CF4]: 'Призы за выполнение плана',
    [CalculationFunctionValuesEnum.CF5]: 'Прохождение аудита',
    [CalculationFunctionValuesEnum.CF6]: 'Заказ (новая механика)',
  };

  return mapper[value] || '';
};
